var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkCoinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#5dd39e",
    opacity: 1,
    "data-original": "#b2ecfe",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ec597",
    d: "M321 93.429 176.862 237.567l60.001 60.001L121.001 413.43l95.543 95.543A258.024 258.024 0 0 0 256 512c132.261 0 241.086-100.302 254.583-228.988z",
    opacity: 1,
    "data-original": "#72d5fd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe40b",
    d: "M121.001 93.429v45.714l8 22.857-8 22.858v45.714l8 22.857-8 22.857V322l8 22.858-8 22.857v45.714h100l14.529-160-14.529-160z",
    opacity: 1,
    "data-original": "#fdd437",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6d409",
    d: "M321.001 93.429h-100v320h100v-45.714l-7-22.857 7-22.858v-45.714l-7-22.857 7-22.857v-45.714l-7-22.858 7-22.857z",
    opacity: 1,
    "data-original": "#faba35",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6d409",
    d: "M121.001 230.572v45.714h100l14.529-22.857-14.529-22.857z",
    opacity: 1,
    "data-original": "#faba35",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcb700",
    d: "M221.001 230.572h100v45.714h-100z",
    opacity: 1,
    "data-original": "#fb9528",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6d409",
    d: "M121.001 139.143v45.715h100L235.53 162l-14.529-22.857z",
    opacity: 1,
    "data-original": "#faba35",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcb700",
    d: "M221.001 139.143h100v45.714h-100z",
    opacity: 1,
    "data-original": "#fb9528",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6d409",
    d: "M121.001 322v45.715h100l14.529-22.857L221.001 322z",
    opacity: 1,
    "data-original": "#faba35",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcb700",
    d: "M221.001 322h100v45.714h-100z",
    opacity: 1,
    "data-original": "#fb9528",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe40b",
    d: "M321.001 230.572c-55.228 0-100 44.772-100 100s44.772 100 100 100l32.352-100z",
    opacity: 1,
    "data-original": "#fdd437",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6d409",
    d: "M421.001 330.572c0-55.157-44.869-99.88-100-99.995v199.989c55.131-.114 100-44.837 100-99.994z",
    opacity: 1,
    "data-original": "#faba35",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6d409",
    d: "M321.001 265.572c-35.898 0-65 29.102-65 65s29.102 65 65 65l20.529-65z",
    opacity: 1,
    "data-original": "#faba35",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcb700",
    d: "M386.001 330.572c0-35.852-29.165-64.922-65-64.996v129.993c35.835-.075 65-29.145 65-64.997z",
    opacity: 1,
    "data-original": "#fb9528",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkCoinsIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-coins-icon.e83f7a8e25ed370790cce9217763551b.svg";
export { ForwardRef as ReactComponent };